import { render, staticRenderFns } from "./KlaimCCPublicManifest.vue?vue&type=template&id=432d99c3&"
import script from "./KlaimCCPublicManifest.vue?vue&type=script&lang=js&"
export * from "./KlaimCCPublicManifest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports